import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ChequeService } from '../../../shared/services/cheque.service';
import { TdSearchBoxComponent, ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdDialogService, TdLoadingService, ITdDataTableSortChangeEvent, IPageChangeEvent } from '@covalent/core';
import { Cheque } from '../cheque';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../branch';
import { SettingsService } from '../../../shared/services/settings.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ExportService } from '../../../shared/services/export.service';
import { DepositChequeDialogComponent } from '../../../shared/dialogs/deposit-cheque-dialog/deposit-cheque-dialog.component';
import { MdDialogRef } from '@angular/material';
import { InvoiceService } from '../../../shared/services/invoice.service';
import { BankService } from '../../../shared/services/bank.service';
import { ReportService } from '../../../shared/services/report.service';
import { BranchService } from '../branches/branch.service';
import { AccountingService } from '../accounting.service';
import { Payment } from '../payment';
import { PaymentInvoice } from '../payment-invoice';
import { Utils } from '../../../shared/utils';

@Component({
  selector: 'app-cheques-list',
  templateUrl: './cheques-list.component.html',
  styleUrls: ['./cheques-list.component.scss'],
  providers: [ChequeService, InvoiceService, BankService, ReportService]
})
export class ChequesListComponent implements OnInit {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Cheque[];
  subscription: Subscription = new Subscription();

  allBranches$: Observable<Branch[]>;

  transaction_status: string[] = [];
  confirmation_length: number = 0;

  branchFilter: string = 'ALL';
  _creating: boolean = false;

  columns: ITdDataTableColumn[] = [
    { name: 'id', label: 'Cheque #', },
    { name: 'customer', label: 'Client' },
    { name: 'amount', label: 'Amount' },
    { name: 'maturity_date', label: 'Maturity Date' },
    { name: 'endorsement', label: 'Endorsement' },
    { name: 'branch', label: 'Branch' },
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 5;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  all_cheques: Cheque[];

  settle_accounts: any[];

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _chequeService: ChequeService,
    private _invoiceService: InvoiceService,
    private _bankService: BankService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    private _branchService: BranchService,
    private _reportService: ReportService,
    public _authService: AuthenticationService,
    public _accountingService: AccountingService) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.getCheques();

    //this.allBranches$ = this._branchService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  getCheques() {
    this.subscription = this._chequeService
      .getCheques()
      .subscribe(
        (cheques: Cheque[]) => {
          this.all_cheques = cheques;

          this.data = this.all_cheques.slice();
          this.data = this.all_cheques.slice().filter(c => { return this._authService.getUserBranches().some(b => { return c.branch_id == b.id }) });
          /*
          this.filteredData = this.data;
          this.filteredTotal = this.data.length;
          this.selectedRows = this.filteredData;
          */
          this.filter();
          this._loadingService.resolve('loading');

        },
        error => {
          this._loadingService.resolve('loading');
        });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('cheque')) {
      this._searchBox.value = this._settingsService.getSearchTerm('cheque');
      this._searchBox.searchClicked();
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;

    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;

    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('cheque', searchTerm);
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    // Need to filter by branch?
    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['branch_code'] == this.branchFilter });
    }

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('cheque'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  reportStatus(status: string, prepend?: boolean) {
    if (prepend) {
      this.transaction_status.unshift(status);
    } else {
      this.transaction_status.push(status);
    }

    if (this.transaction_status.length == this.confirmation_length) {
      let len = this.transaction_status.length;

      this._dialogService.openAlert(
        {
          title: 'Result',
          // if longer than 10 only show the first 10
          message: this.transaction_status.slice(0, 10).join(', ') +
            (len > 10 ? '... and ' + (len - 10) + ' more' : '')
        }
      ).afterClosed().subscribe(
        result => {
          this.getCheques();
          this.selectedRows = [];
        });
    }
  }

  deposit() {
    this._loadingService.register('loading');
    this._creating = true;

    let dRef: MdDialogRef<DepositChequeDialogComponent> = this._dialogService.open(DepositChequeDialogComponent);

    dRef.componentInstance.items = this.selectedRows;
    dRef.componentInstance.description = this.selectedRows.map(i => i.customer_name + ' cheque ' + i.cheque_number).join(', ')

    dRef.afterClosed().subscribe(
      result => {
        if (result) {
          if (result.cheques && Array.isArray(result.cheques)) {

            // We will run one at least (deposit into bank)
            this.confirmation_length = 1;
            // we also do two per cheque (search related, settle cheque)
            this.confirmation_length += result.cheques.length;

            //for each cheque          
            result.cheques.forEach(
              chk => {

                let cheque: Cheque = chk;

                let payment: Payment = new Payment(
                  {
                    effective_date: result.effective_date,
                    type: 'Payment',
                    customer_id: cheque.customer_id,
                    amount: cheque.amount,
                    notes: 'Deposit of Cheque# ' + cheque.cheque_number
                  }
                );

                // add a payment for each cheque here and store it's ID
                this._accountingService.createPayment(payment).subscribe(
                  response => {
                    console.log("results: " + response);
                    let _paymentId = response['id'];


                    //find all related invoices
                    this._chequeService.getRelatedInvoices(chk.id).subscribe(
                      relatedInvoices => {
                        this.reportStatus('Retrieved all related invoices for ' + chk.cheque_number);
                        if (relatedInvoices && Array.isArray(relatedInvoices)) {

                          //for each related invoice
                          relatedInvoices.forEach(
                            invoice => {
                              //settle invoice cheque part
                              this._invoiceService.getOneInvoice(invoice.invoice_id).subscribe(
                                actualInvoice => {
                                  if (actualInvoice && Array.isArray(actualInvoice)) {
                                    let _theActualInvoice = actualInvoice[0];
                                    // Remove the amount from "cheques" and add it to "processed"
                                    this._invoiceService.updateInvoice(
                                      Number.parseInt(_theActualInvoice.id),
                                      Number.parseFloat(_theActualInvoice.processed + '') + Number.parseFloat(invoice.amount),
                                      Number.parseFloat(_theActualInvoice.cheques + '') - Number.parseFloat(invoice.amount)
                                    ).subscribe(
                                      response => {

                                        // add a payment invoice for each invoice updated
                                        let invoices: PaymentInvoice[] = [];

                                        invoices.push(new PaymentInvoice(
                                          {
                                            invoice_id: Number.parseInt(_theActualInvoice.id),
                                            payment_id: _paymentId,
                                            amount: Number.parseFloat(invoice.amount),
                                            type: 'Deposit',
                                            effective_date: result.effective_date
                                          }
                                        )); 

                                        this._accountingService.createPaymentInvoice(invoices).subscribe(
                                          response => {

                                            let _paymentInvoiceId = response['id'];
                                            console.log ('Payment Invoice entry created for Payment ID: ' + _paymentId + ' and invoice ID: ' + _theActualInvoice.id);
                                          },
                                          error => {
                                            this._dialogService.openAlert({
                                              title: 'Error',
                                              message: 'Error creating invoice payment entry for Payment ID: ' + _paymentId + ' and invoice ID: ' + _theActualInvoice.id + ', please notify support.'
                                            });
                                
                                          }
                                        );

                                      }
                                    );
                                  }
                                }
                              );
                            }
                          )
                        }
                      },
                      error => {
                        this.reportStatus('Could not fetch related invoices for check ' + chk.cheque_number);
                      }
                    );

                  },
                  error => {
                    this._dialogService.openAlert({
                      title: 'Error',
                      message: 'Error creating payment, please notify support'
                    });

                  }
                );

                //mark the check as settled
                this._chequeService.settleCheque(chk.id, result.effective_date).subscribe(
                  settleResult => {
                    this.reportStatus('Cheque ' + chk.cheque_number + ' settled');
                  },
                  error => {
                    this.reportStatus('Cheque ' + chk.cheque_number + ' could NOT be settled');
                  }
                );
              }
            );
            //make the deposit for the total in the bank
            //TODO: making cheques settled and depositing don't appear to be atomic here, that could cause problems.. maybe move it to the backend or a stored procedure?
            this._bankService.deposit(
              result.bank_id,
              result.description,
              this.selectedRows.reduce((a, b) => { return a * 1 + b.amount * 1 }, 0),
              result.effective_date
            ).subscribe(
              depositResult => {
                console.log('Value deposited in the selected bank');
                this._loadingService.resolve('loading');
                this._creating = false;
              }, error => {
                console.log('Error depositing the value in the selected bank');
                this._loadingService.resolve('loading');
                this._creating = false;
              }
            )
          }
        } else {
          this._loadingService.resolve('loading');
          this._creating = false;
        }
      }
    );

  }

  // Save the payment and all associated payment invoices
  payment(payment: Payment, invoices: PaymentInvoice[]) {

    this._accountingService.createPayment(payment).subscribe(
      response => {
        console.log("results: " + response);
        let _paymentId = response['id'];

        // Set the payment ID to the returned value for each of the entries
        invoices.forEach(invoice => {
          invoice.payment_id = _paymentId;
        });

        this._accountingService.createPaymentInvoice(invoices).subscribe(
          response => {
            this._dialogService.openAlert({
              title: 'Success',
              message: 'Payment ID: ' + _paymentId + ' and ' + response.length + ' Payment Invoice entries created.'
            });
          },
          error => {
            this._dialogService.openAlert({
              title: 'Error',
              message: 'Error creating invoice payment entries for Payment ID: ' + _paymentId + ', please notify support.'
            });

          }
        );
      },
      error => {
        this._dialogService.openAlert({
          title: 'Error',
          message: 'Error creating payment, please notify support'
        });

      }
    );
  }

  cecReport() {
    this._reportService.cecReport(this.data);
  }

  totalSelected() {
    return this.selectedRows.reduce((a, b) => { return a * 1 + b.amount * 1 }, 0);
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/cheques-list/cheques-list.component.ts